export const CONCLUIDO = () => `/concluido`;
